import { Button, Select, Option, selectClasses, Textarea, Tooltip, OptionProps, RadioGroup, Radio, Checkbox, Input } from "@mui/joy";

import { BASE_URL, BLACK, FLASK_EXCEL_API_URL, PRIMARY, STATUS } from "../../appConstants";
import AddMainCategoryModal from "./AddMainCategoryModal";
import { useEffect, useState } from "react";
import axios from "axios";
import { UUID } from "crypto";
import { AgGridReact } from "ag-grid-react";
import { ColDef, GroupCellRendererParams } from "ag-grid-community";
import xlsx_to_json from "../../appFunctions";
import { v4 as uuidv4 } from "uuid"
import * as React from 'react';
import SvgIcon from '@mui/joy/SvgIcon';
import { styled } from '@mui/joy';
import toast from "react-hot-toast";
import appError from "../../appError";

import Joi from "joi";
import { useSelector } from "react-redux";
type BrandProductObject = {
    id?: string,
    brand_product_code: string,

    brand_product_code_status?: string,
    brand_product_code_message?: string,

    brand_product_sku_id: string,

    brand_product_sku_id_status?: string,
    brand_product_sku_id_message?: string,

    brand_sub_category?: string,

    brand_sub_category_status?: string,
    brand_sub_category_message?: string,

    platform?: string,

    brand_platform_status?: string,
    brand_platform_message?: string
}






type SubCategorybject = {
    brand_sub_category: string,
    brand_sub_category_id: UUID
}



type PlatformObject = {
    platform: string,
    platform_id: UUID
}


const Product = () => {
    const brandId = useSelector((state: any) => state.appData.brand_id);
    const scrollContainerRef = React.useRef<HTMLDivElement | null>(null);

    const [open, setOpen] = useState<boolean>(false);
    const [subCategories, seSubCategories] = useState<SubCategorybject[]>();
    const [rowData, setRowData] = useState<BrandProductObject[]>([]);
    const [formArray, setFormArry] = useState<BrandProductObject[]>([]);
    const [formData, setFormData] = useState({
        brand_product_code: "",
        brand_product_sku_id: ""
    });
    const [selectedSubCategory, setSelectedSubCategory] = useState<string>("");
    const [keywordString, setKeywordString] = useState<string>("");


    const [platforms, setPlatforms] = useState<PlatformObject[]>([]);
    // const [selectedBrandPlatform, setSelectedBrandPlatform] = useState<any>({});
    const [selectedBrandPlatform, setSelectedBrandPlatform] = useState<string>("");
    const [loadingUploadExcel, setLoadingUploadExcel] = useState<boolean>(false);
    const [loadingSave, setLoadingSave] = useState<boolean>(false);
    const VisuallyHiddenInput = styled('input')`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  white-space: nowrap;
  width: 1px;
`;
    useEffect(() => {
        fetchSubCategories();
        fetchPlatforms();
    }, []);

    useEffect(() => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTop = scrollContainerRef.current.scrollHeight;
        }
    }, [formArray]);


    //Fetch Main Categories Function
    const fetchSubCategories = async () => {
        try {
            const token = localStorage.getItem("token");

            const res = await axios.get(`${BASE_URL}onboarding/subCategories?brand_id=${brandId}`, {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            const { brand_sub_category_array } = res?.data?.data;
            seSubCategories(brand_sub_category_array);
        } catch (error) {
            appError(error);
        }
    }



    const fetchPlatforms = async () => {
        try {
            const token = localStorage.getItem("token");

            const res = await axios.get(`${BASE_URL}onboarding/platforms?brand_id=${brandId}`, {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            const { platform_array } = res?.data?.data;
            setPlatforms(platform_array);
        } catch (error) {
            appError(error);
        }
    }





    // const getRowHeight = (params: any) => {
    //     const { data: { brand_sub_category_array } } = params
    //     return brand_sub_category_array.length * 50
    // }

    // const onRemoveSubCategoryClickHandler = (obj: BrandProductObject, index: number) => {
    //     setRowData((prevState: RowObject[]) => {
    //         let newSate = [];
    //         for (let el of prevState) {
    //             if (el.brand_sub_category === obj?.brand_sub_category && el.platform === obj?.platform && el.brand_keyword_type === obj?.brand_keyword_type) {
    //                 let keywordArray: BrandProductObject[] | any = el?.brand_keyword_array?.slice(0, index).concat(el?.brand_keyword_array?.slice(index + 1));
    //                 el.brand_keyword_array = keywordArray;
    //                 if (keywordArray.length) {
    //                     el.brand_keyword_array = keywordArray;
    //                     newSate.push({ ...el });
    //                 }
    //             } else {
    //                 newSate.push(el);
    //             }
    //         }
    //         return newSate;
    //     });
    // }

    // const KeywordComponent = (props: any) => {
    //     //const { data: { brand_sub_category_array, brand_main_category } } = props;
    //     const { brand_keyword_array } = props;
    //     return (
    //         <div className="flex flex-row flex-wrap w-full  h-full pt-2 pb-2 overflow-scroll" >
    //             {
    //                 brand_keyword_array?.map((el: BrandProductObject, index: number) => {
    //                     return (
    //                         <Tooltip key={el?.id} arrow title={el?.brand_keyword_message} color="danger" placement="top" variant={"outlined"}>
    //                             <div className="flex items-center justify-center m-1 max-w-fit px-2 py-1" style={{ fontSize: 14, fontWeight: 400, backgroundColor: el.brand_keyword_status === "error" ? STATUS.S_Red : BLACK.B_10, color: el.brand_keyword_status === "error" ? BLACK.B_100 : BLACK.B_40, height: 28, borderRadius: 8 }} >
    //                                 {el?.brand_keyword}
    //                                 <div onClick={() => onRemoveSubCategoryClickHandler(el, index)} className="ml-1 max-w-fit cursor-pointer" >
    //                                     <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 16 16" fill="none">
    //                                         <path d="M10.3538 6.35375L8.70688 8L10.3538 9.64625C10.4002 9.6927 10.4371 9.74786 10.4622 9.80855C10.4873 9.86925 10.5003 9.9343 10.5003 10C10.5003 10.0657 10.4873 10.1308 10.4622 10.1914C10.4371 10.2521 10.4002 10.3073 10.3538 10.3538C10.3073 10.4002 10.2521 10.4371 10.1915 10.4622C10.1308 10.4873 10.0657 10.5003 10 10.5003C9.93431 10.5003 9.86925 10.4873 9.80855 10.4622C9.74786 10.4371 9.69271 10.4002 9.64625 10.3538L8 8.70687L6.35375 10.3538C6.3073 10.4002 6.25215 10.4371 6.19145 10.4622C6.13075 10.4873 6.0657 10.5003 6 10.5003C5.93431 10.5003 5.86925 10.4873 5.80855 10.4622C5.74786 10.4371 5.69271 10.4002 5.64625 10.3538C5.5998 10.3073 5.56295 10.2521 5.53781 10.1914C5.51266 10.1308 5.49972 10.0657 5.49972 10C5.49972 9.9343 5.51266 9.86925 5.53781 9.80855C5.56295 9.74786 5.5998 9.6927 5.64625 9.64625L7.29313 8L5.64625 6.35375C5.55243 6.25993 5.49972 6.13268 5.49972 6C5.49972 5.86732 5.55243 5.74007 5.64625 5.64625C5.74007 5.55243 5.86732 5.49972 6 5.49972C6.13268 5.49972 6.25993 5.55243 6.35375 5.64625L8 7.29313L9.64625 5.64625C9.69271 5.59979 9.74786 5.56294 9.80855 5.5378C9.86925 5.51266 9.93431 5.49972 10 5.49972C10.0657 5.49972 10.1308 5.51266 10.1915 5.5378C10.2521 5.56294 10.3073 5.59979 10.3538 5.64625C10.4002 5.6927 10.4371 5.74786 10.4622 5.80855C10.4873 5.86925 10.5003 5.9343 10.5003 6C10.5003 6.0657 10.4873 6.13075 10.4622 6.19145C10.4371 6.25214 10.4002 6.3073 10.3538 6.35375ZM14.5 8C14.5 9.28558 14.1188 10.5423 13.4046 11.6112C12.6903 12.6801 11.6752 13.5132 10.4874 14.0052C9.29973 14.4972 7.99279 14.6259 6.73192 14.3751C5.47104 14.1243 4.31285 13.5052 3.40381 12.5962C2.49477 11.6872 1.8757 10.529 1.6249 9.26809C1.37409 8.00721 1.50282 6.70028 1.99479 5.51256C2.48676 4.32484 3.31988 3.30968 4.3888 2.59545C5.45772 1.88122 6.71442 1.5 8 1.5C9.72335 1.50182 11.3756 2.18722 12.5942 3.40582C13.8128 4.62441 14.4982 6.27665 14.5 8ZM13.5 8C13.5 6.9122 13.1774 5.84883 12.5731 4.94436C11.9687 4.03989 11.1098 3.33494 10.1048 2.91866C9.09977 2.50238 7.9939 2.39346 6.92701 2.60568C5.86011 2.8179 4.8801 3.34172 4.11092 4.11091C3.34173 4.8801 2.8179 5.86011 2.60568 6.927C2.39347 7.9939 2.50238 9.09977 2.91867 10.1048C3.33495 11.1098 4.0399 11.9687 4.94437 12.5731C5.84884 13.1774 6.91221 13.5 8 13.5C9.45819 13.4983 10.8562 12.9184 11.8873 11.8873C12.9184 10.8562 13.4983 9.45818 13.5 8Z" fill="#1C1C1C" fill-opacity="0.8" />
    //                                     </svg>
    //                                 </div>
    //                             </div>
    //                         </Tooltip>
    //                     )
    //                 })
    //             }
    //         </div>
    //     )
    // }



    const validateProduct = async (brand_product_array: BrandProductObject[] | any) => {
        try {
            const token = localStorage.getItem("token");

            const res = await axios.post(`${BASE_URL}onboarding/validate/products?brand_id=${brandId}`,
                { brand_product_array },
                {
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                }
            );
            return res?.data?.data?.brand_product_array
        } catch (error: any) {
         
            throw (new Error(error));
        }
    }

    const fillErrorAndMessageInProduct = async (apiResponseProducts: BrandProductObject[], userEnteredProducts: BrandProductObject[]) => {

        for (let el of userEnteredProducts) {
            const { id } = el;
            let errorObjectOfProduct = apiResponseProducts.find((e) => e.id === id);
            if (errorObjectOfProduct) {
                const {
                    brand_product_code_status, brand_product_code_message,
                    brand_platform_status, brand_platform_message,
                    brand_sub_category_status, brand_sub_category_message
                } = errorObjectOfProduct
                if (brand_product_code_status === "error") {
                    el.brand_product_code_status = brand_product_code_status;
                    el.brand_product_code_message = brand_product_code_message
                }
                if (brand_platform_status === "error") {
                    el.brand_platform_status = brand_platform_status;
                    el.brand_platform_message = brand_platform_message;
                }
                if (brand_sub_category_status === "error") {
                    el.brand_sub_category_status = brand_sub_category_status;
                    el.brand_sub_category_message = brand_sub_category_message;
                }
            }
        }


        return userEnteredProducts;
    }

    const onDeleteClickHandler = (id: string | any) => {
        
        setRowData(prevState => {
            let newState = [];
            for (let el of prevState) {
                if (el.id != id) {
                    newState.push(el);
                }
            }
            return newState;
        })
       
       
    }

    const onFileChangeHandler = async (event: React.ChangeEvent<HTMLInputElement>) => {
        if (!(event.target.files && event.target.files.length > 0)) {
            return;
        }

        try {
            setLoadingUploadExcel(true);
            let brand_product_array: BrandProductObject[] = await xlsx_to_json(event.target.files[0]);
            brand_product_array.forEach(el => {
                el.id = uuidv4();
            });

            for (let i in brand_product_array) {
                let { brand_product_code, brand_product_sku_id, platform, brand_sub_category } = brand_product_array[i];
                brand_product_code = brand_product_code?.toString()?.trim();
                brand_product_sku_id = brand_product_sku_id?.toString()?.trim();
                platform = platform?.toString()?.trim();
                brand_sub_category = brand_sub_category?.toString()?.trim();
               

                if (!brand_product_code || !brand_product_sku_id || !platform || !brand_sub_category) {
                    appError(`Please fill in all the values in row number ${(parseInt(i) + 2)}.`);
                    return;
                }
                brand_product_array[i].brand_product_code = brand_product_code;
                brand_product_array[i].brand_product_sku_id = brand_product_sku_id;
                brand_product_array[i].platform = platform;
                brand_product_array[i].brand_sub_category = brand_sub_category;
                brand_product_array[i].id = uuidv4();
            }





            const res: BrandProductObject[] = await validateProduct(brand_product_array);
            const setProductCode = new Set();
            brand_product_array.forEach(el => {
                const { brand_product_code } = el;
                if (setProductCode.has(brand_product_code)) {
                    el.brand_product_code_status = "error";
                    el.brand_product_code_message = "Duplicate Product Code.";
                } else {
                    setProductCode.add(brand_product_code);
                }

            });
            let res_brand_product_array: BrandProductObject[] = await fillErrorAndMessageInProduct(res, brand_product_array);
            setRowData(res_brand_product_array)
        } catch (error) {
        
            appError(error);

        } finally {
            setLoadingUploadExcel(false);
        }
    }





    const onSaveClickHandler = async () => {
        try {
            setLoadingSave(true);
            let brand_product_array: BrandProductObject[] = [];

            for (let el of rowData) {
                const { brand_product_code, brand_product_sku_id, brand_sub_category, platform } = el;
                if (el?.brand_product_code_status === "error" || el?.brand_product_sku_id_status === "error") {
                    toast.error("Please remove all elements marked as red color.");
                    return
                }
                brand_product_array.push({ brand_product_code, brand_product_sku_id, brand_sub_category, platform });
            }

            if (!brand_product_array.length) {
                return
            }

            const token = localStorage.getItem("token");

          

            const res = await axios.post(`${BASE_URL}onboarding/products?brand_id=${brandId}`,
                {
                    brand_product_array
                },
                {
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                });

            const { message } = res?.data?.data;
           
            toast.success(message);
            setRowData([]);
        } catch (error) {
            appError(error);
        } finally {
            setLoadingSave(false);
        }
    }


    const onSelectSubCategoryHandler = (event: any, value: any) => {
        setSelectedSubCategory(value);
    }

    // const onInsertClickHandler = async () => {



    //     if (!selectedBrandPlatform) {
    //         toast.error("Please select platform.");
    //         return
    //     }
    //     if (!selectedSubCategory.trim()) {
    //         toast.error("Please select Sub Category.");
    //         return
    //     }


    //     let brand_keyword_array: BrandProductObject[] = []
    //     for (let keyword of validatedKeywordArray) {
    //         for (let platform of selectedBrandPlatforms) {
    //             brand_keyword_array.push({
    //                 brand_keyword: keyword,
    //                 platform: platform,
    //                 brand_keyword_type: selectedKeywordType,
    //                 brand_sub_category: selectedSubCategory
    //             })
    //         }
    //     }


    //     try {
    //         const res: BrandProductObject[] = await validateProduct(brand_keyword_array);
    //         brand_keyword_array.forEach(el => {
    //             el.id = uuidv4();
    //         })
    //         const res_brand_sub_category_array: RowObject[] = await fillErrorAndMessageInProduct(res, brand_keyword_array);
    //         const set = new Set();
    //         for (let el of rowData) {
    //             const brand_keyword_array: any = el?.brand_keyword_array;
    //             for (let keywordObject of brand_keyword_array) {
    //                 set.add(keywordObject?.brand_keyword);
    //             }
    //         }

    //         for (let el of res_brand_sub_category_array) {
    //             const brand_keyword_array: any = el?.brand_keyword_array;
    //             for (let keywordObject of brand_keyword_array) {
    //                 if (set.has(keywordObject?.brand_keyword)) {
    //                     keywordObject.error = true;
    //                     keywordObject.message = "Duplicate Sub Category."
    //                 } else {
    //                     set.add(keywordObject?.brand_keyword);
    //                 }

    //             }
    //         }

    //         setRowData(prevState => {


    //             for (let row of res_brand_sub_category_array) {
    //                 const keywordObject = prevState.find(el => (el?.platform === row?.platform && el?.brand_keyword_type === row?.brand_keyword_type && el?.brand_sub_category === row?.brand_sub_category));
    //                 if (keywordObject) {
    //                     const brand_keyword_array: any = row?.brand_keyword_array;
    //                     keywordObject?.brand_keyword_array?.push(...brand_keyword_array)
    //                 } else {
    //                     prevState.push({
    //                         id: uuidv4(),
    //                         brand_sub_category: row?.brand_sub_category,
    //                         brand_keyword_type: row?.brand_keyword_type,
    //                         platform: row?.platform,
    //                         brand_keyword_array: row?.brand_keyword_array
    //                     })
    //                 }
    //             }


    //             return [...prevState]
    //         });
    //         setSelectedSubCategory("");
    //         setKeywordString("");
    //         setSelectedBrandPlatform("");
    //         setSelectedKeywordType("");
    //     } catch (error) {
    //         appError(error);
    //     } finally {

    //     }

    // }
    const onChangeKeywordHandler = ({ target: { value } }: React.ChangeEvent<HTMLTextAreaElement>) => {
        setKeywordString(value);
    }




    // const onSelectPlatformHandler = ({ target: { checked, value } }: React.ChangeEvent<any>) => {
    //     setSelectedBrandPlatform((prevState: any) => {
    //         prevState[value] = checked;
    //         return prevState;
    //     });
    // }
    const onSelectPlatformHandler = (event: any, value: any) => {
        setSelectedBrandPlatform(value);
    }


    // const getRowId = React.useCallback((params: any) => params.data.id, []);


    const onFormInputChangeHandler = ({ target: { value, name } }: React.ChangeEvent<HTMLInputElement>) => {
        setFormData(prevState => ({ ...prevState, [name]: value }));
    }



    const onInsertClickHandler = async () => {
        try {

            if (!selectedBrandPlatform) {
                toast.error("Please select Platform.");
                return;
            }
            if (!selectedSubCategory) {
                toast.error("Please select sub category.");
                return;
            }


            let brand_product_array: BrandProductObject[] = [...formArray];
            brand_product_array.forEach(el => {
                el.id = uuidv4();
                el.platform = selectedBrandPlatform;
                el.brand_sub_category = selectedSubCategory;
            })
            const res: BrandProductObject[] = await validateProduct(brand_product_array);
            const setProductCode = new Set();
            if (rowData.length > 0) {
                for (let row of rowData) {
                    setProductCode.add(row.brand_product_code);
                }
            }
            brand_product_array.forEach(el => {
                const { brand_product_code } = el;
                if (setProductCode.has(brand_product_code)) {
                    el.brand_product_code_status = "error";
                    el.brand_product_code_message = "Duplicate Product Code.";
                } else {
                    setProductCode.add(brand_product_code);
                }

            });
            let res_brand_product_array: BrandProductObject[] = await fillErrorAndMessageInProduct(res, brand_product_array);
            setRowData(prevState => ([...res_brand_product_array, ...prevState]));
            setFormData({
                brand_product_code: "",
                brand_product_sku_id: ""
            });
            setFormArry([])
            setSelectedBrandPlatform("");
            setSelectedSubCategory("");
        } catch (error) {
            appError(error);
        }
    }

    const onAddClickHandler = () => {
        const { brand_product_code, brand_product_sku_id } = formData;
        if (!brand_product_code?.trim() || !brand_product_sku_id?.trim()) {
            return
        }
        setFormArry(prevState => {
            const obj = {
                brand_product_code,
                brand_product_sku_id
            };
            return [...prevState, obj];
        });
        setFormData({
            brand_product_code: "",
            brand_product_sku_id: ""
        });
    }

    return (
        <div className="flex flex-col pt-8 px-10 h-full" >
            {/* Header */}
            <div className="flex flex-row items-center mb-5" style={{ height: 62 }} >
                <div className="w-full" >
                    <div style={{ fontSize: 24, fontWeight: 500 }}>Product</div>
                    <div style={{ fontSize: 18, fontWeight: 400, color: BLACK.B_40 }} >You can manually add your Products here or either you can upload it from our structured excel format.</div>
                </div>
                <Button
                    variant="outlined"
                    sx={{
                        height: "56px",
                        width: "128px",
                        ":hover": { cursor: "pointer" }
                    }}
                    startDecorator={<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M19.3211 9.74688C19.2937 9.68516 18.632 8.21719 17.1609 6.74609C15.2008 4.78594 12.725 3.75 9.99999 3.75C7.27499 3.75 4.79921 4.78594 2.83905 6.74609C1.36796 8.21719 0.703118 9.6875 0.678899 9.74688C0.643362 9.82681 0.625 9.91331 0.625 10.0008C0.625 10.0883 0.643362 10.1748 0.678899 10.2547C0.706243 10.3164 1.36796 11.7836 2.83905 13.2547C4.79921 15.2141 7.27499 16.25 9.99999 16.25C12.725 16.25 15.2008 15.2141 17.1609 13.2547C18.632 11.7836 19.2937 10.3164 19.3211 10.2547C19.3566 10.1748 19.375 10.0883 19.375 10.0008C19.375 9.91331 19.3566 9.82681 19.3211 9.74688ZM9.99999 15C7.5953 15 5.49452 14.1258 3.75546 12.4023C3.0419 11.6927 2.43483 10.8836 1.95312 10C2.4347 9.11636 3.04179 8.30717 3.75546 7.59766C5.49452 5.87422 7.5953 5 9.99999 5C12.4047 5 14.5055 5.87422 16.2445 7.59766C16.9595 8.307 17.5679 9.11619 18.0508 10C17.4875 11.0516 15.0336 15 9.99999 15ZM9.99999 6.25C9.25831 6.25 8.53329 6.46993 7.9166 6.88199C7.29992 7.29404 6.81927 7.87971 6.53544 8.56494C6.25162 9.25016 6.17735 10.0042 6.32205 10.7316C6.46674 11.459 6.82389 12.1272 7.34834 12.6517C7.87279 13.1761 8.54097 13.5333 9.2684 13.6779C9.99583 13.8226 10.7498 13.7484 11.4351 13.4645C12.1203 13.1807 12.7059 12.7001 13.118 12.0834C13.5301 11.4667 13.75 10.7417 13.75 10C13.749 9.00576 13.3535 8.05253 12.6505 7.34949C11.9475 6.64645 10.9942 6.25103 9.99999 6.25ZM9.99999 12.5C9.50554 12.5 9.02219 12.3534 8.61107 12.0787C8.19994 11.804 7.87951 11.4135 7.69029 10.9567C7.50107 10.4999 7.45157 9.99723 7.54803 9.51227C7.64449 9.02732 7.88259 8.58186 8.23222 8.23223C8.58186 7.8826 9.02731 7.6445 9.51227 7.54804C9.99722 7.45157 10.4999 7.50108 10.9567 7.6903C11.4135 7.87952 11.804 8.19995 12.0787 8.61107C12.3534 9.0222 12.5 9.50555 12.5 10C12.5 10.663 12.2366 11.2989 11.7678 11.7678C11.2989 12.2366 10.663 12.5 9.99999 12.5Z" fill="#1886FE" />
                    </svg>
                    }
                >View</Button>

            </div>
            {/* Container */}
            <div style={{ border: `1px solid ${BLACK.B_10}`, borderRadius: 8 }} className="flex flex-row mb-6 p-4 h-full" >
                {/* Left Container */}
                <div className="flex flex-col  w-full pr-6 h-full" style={{ borderRight: `1px solid ${BLACK.B_10}` }} >
                    {/* Header */}
                    <div className="flex items-center justify-between" >
                        <div className="flex flex-col justify-between" style={{ height: 72 }}  >
                            <div style={{ fontSize: 18, fontWeight: 500 }}>Add your Product Code</div>
                            <div style={{ fontSize: 14, fontWeight: 40, color: BLACK.B_40, width: 296 }}>Manually add your Product Code or upload your excel file here.</div>
                        </div>
                        <div className="flex items-center" >
                            <Button
                                component="a"
                                size="sm"
                                sx={{
                                    borderRadius: 8,
                                    marginRight: "16px"
                                }}
                                href={`${FLASK_EXCEL_API_URL}onBoardingExcels?brand_id=${brandId}&module=product`}
                                onClick={() => {
                                    toast.loading("Please wait download will start 👆 soon.", {
                                        duration: 3000
                                    })
                                }}
                            > Download Template</Button>
                            {/* <input type="file" onChange={onFileChangeHandler} /> */}
                            <Button
                                loading={loadingUploadExcel}
                                component="label"
                                role={undefined}
                                tabIndex={-1}
                                variant="outlined"
                                color="neutral"
                                size="sm"
                                sx={{
                                    color: PRIMARY.P_BLue,
                                    borderColor: PRIMARY.P_BLue,
                                    borderRadius: "8px",
                                }}
                                startDecorator={
                                    <SvgIcon>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            strokeWidth={1.5}
                                            stroke="currentColor"
                                        >
                                            <path
                                                color={PRIMARY.P_BLue}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M12 16.5V9.75m0 0l3 3m-3-3l-3 3M6.75 19.5a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z"
                                            />
                                        </svg>
                                    </SvgIcon>
                                }
                            >
                                Upload Excel
                                <VisuallyHiddenInput onChange={onFileChangeHandler} type="file" />
                            </Button>

                        </div>

                    </div>
                    <div className="flex items-start mt-9" >
                        <div style={{ fontSize: 14, fontWeight: 500, minWidth: 110 }} >Platform</div>
                        <Select
                            value={selectedBrandPlatform}
                            onChange={onSelectPlatformHandler}
                            placeholder="Select Platform"
                            indicator={<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g id="Iconography">
                                    <path id="Vector" d="M13.354 6.35354L8.35403 11.3535C8.30759 11.4 8.25245 11.4369 8.19175 11.4621C8.13105 11.4872 8.06599 11.5002 8.00028 11.5002C7.93457 11.5002 7.86951 11.4872 7.80881 11.4621C7.74811 11.4369 7.69296 11.4 7.64653 11.3535L2.64653 6.35354C2.55271 6.25972 2.5 6.13247 2.5 5.99979C2.5 5.86711 2.55271 5.73986 2.64653 5.64604C2.74035 5.55222 2.8676 5.49951 3.00028 5.49951C3.13296 5.49951 3.26021 5.55222 3.35403 5.64604L8.00028 10.2929L12.6465 5.64604C12.693 5.59958 12.7481 5.56273 12.8088 5.53759C12.8695 5.51245 12.9346 5.49951 13.0003 5.49951C13.066 5.49951 13.131 5.51245 13.1917 5.53759C13.2524 5.56273 13.3076 5.59958 13.354 5.64604C13.4005 5.69249 13.4373 5.74764 13.4625 5.80834C13.4876 5.86904 13.5006 5.93409 13.5006 5.99979C13.5006 6.06549 13.4876 6.13054 13.4625 6.19124C13.4373 6.25193 13.4005 6.30708 13.354 6.35354Z" fill="#1886FE" />
                                </g>
                            </svg>}
                            size="sm"
                            sx={{

                                marginLeft: "16px",
                                minWidth: 160,
                                color: PRIMARY.P_BLue,
                                borderRadius: 8,
                                borderColor: PRIMARY.P_BLue,
                                [`& .${selectClasses.indicator}`]: {
                                    transition: '0.2s',
                                    [`&.${selectClasses.expanded}`]: {
                                        transform: 'rotate(-180deg)',
                                    },
                                },
                            }}
                        >
                            {
                                platforms?.map(el => {
                                    return <Option value={el?.platform}  >{el?.platform}</Option>
                                })
                            }
                        </Select>
                    </div>
                    <div className="flex items-center mt-3" >
                        <div style={{ fontSize: 14, fontWeight: 500, minWidth: 110 }} >Sub Category</div>
                        <Select
                            value={selectedSubCategory}
                            onChange={onSelectSubCategoryHandler}
                            placeholder="Select Category"
                            indicator={<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g id="Iconography">
                                    <path id="Vector" d="M13.354 6.35354L8.35403 11.3535C8.30759 11.4 8.25245 11.4369 8.19175 11.4621C8.13105 11.4872 8.06599 11.5002 8.00028 11.5002C7.93457 11.5002 7.86951 11.4872 7.80881 11.4621C7.74811 11.4369 7.69296 11.4 7.64653 11.3535L2.64653 6.35354C2.55271 6.25972 2.5 6.13247 2.5 5.99979C2.5 5.86711 2.55271 5.73986 2.64653 5.64604C2.74035 5.55222 2.8676 5.49951 3.00028 5.49951C3.13296 5.49951 3.26021 5.55222 3.35403 5.64604L8.00028 10.2929L12.6465 5.64604C12.693 5.59958 12.7481 5.56273 12.8088 5.53759C12.8695 5.51245 12.9346 5.49951 13.0003 5.49951C13.066 5.49951 13.131 5.51245 13.1917 5.53759C13.2524 5.56273 13.3076 5.59958 13.354 5.64604C13.4005 5.69249 13.4373 5.74764 13.4625 5.80834C13.4876 5.86904 13.5006 5.93409 13.5006 5.99979C13.5006 6.06549 13.4876 6.13054 13.4625 6.19124C13.4373 6.25193 13.4005 6.30708 13.354 6.35354Z" fill="#1886FE" />
                                </g>
                            </svg>}
                            size="sm"
                            sx={{

                                marginLeft: "16px",
                                minWidth: 160,
                                color: PRIMARY.P_BLue,
                                borderRadius: 8,
                                borderColor: PRIMARY.P_BLue,
                                [`& .${selectClasses.indicator}`]: {
                                    transition: '0.2s',
                                    [`&.${selectClasses.expanded}`]: {
                                        transform: 'rotate(-180deg)',
                                    },
                                },
                            }}
                        >
                            {
                                subCategories?.map(el => {
                                    return <Option value={el?.brand_sub_category}  >{el?.brand_sub_category}</Option>
                                })
                            }
                        </Select>

                    </div>
                    <div className="mt-4 p-4" style={{ backgroundColor: PRIMARY.P_Light }} >
                        <div style={{ height: 32, fontSize: 14, fontWeight: 400, color: BLACK.B_40 }} className="flex flex-row items-center w-full border-b" >
                            <div className="w-1/3">Product Code</div>
                            <div className="w-1/3" >SKU ID</div>
                        </div>
                        <div
                            ref={scrollContainerRef}
                            className="overflow-y-scroll" style={{ height: "calc(100vh - 750px)" }} >
                            {
                                formArray?.map(el => {
                                    return (
                                        <div className="flex items-center my-1" >
                                            <div className="w-1/3" >{el?.brand_product_code}</div>
                                            <div className="w-1/3" >{el?.brand_product_sku_id}</div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        {/* Form */}
                        <div className="flex items-center" >
                            <div className="w-1/3" >
                                <Input
                                    value={formData.brand_product_code}
                                    name="brand_product_code"
                                    size="sm"
                                    placeholder="Product Code"
                                    sx={{
                                        border: `1px dashed ${PRIMARY.P_BLue}`,
                                        marginRight: "32px"
                                    }}
                                    onChange={onFormInputChangeHandler}
                                />
                            </div>
                            <div className="w-1/3" >
                                <Input
                                    value={formData.brand_product_sku_id}
                                    name="brand_product_sku_id"
                                    size="sm"
                                    placeholder="SKU ID"
                                    sx={{
                                        border: `1px dashed ${PRIMARY.P_BLue}`,
                                        marginRight: "32px"
                                    }}
                                    onChange={onFormInputChangeHandler}
                                />
                            </div>
                            <div className="w-1/3" >
                                <Button
                                    startDecorator={
                                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                            <path d="M10.333 1.875C8.72604 1.875 7.15515 2.35152 5.819 3.24431C4.48285 4.1371 3.44145 5.40605 2.82649 6.8907C2.21153 8.37535 2.05063 10.009 2.36413 11.5851C2.67764 13.1612 3.45147 14.6089 4.58777 15.7452C5.72407 16.8815 7.17181 17.6554 8.7479 17.9689C10.324 18.2824 11.9577 18.1215 13.4423 17.5065C14.927 16.8916 16.1959 15.8502 17.0887 14.514C17.9815 13.1779 18.458 11.607 18.458 10C18.4557 7.84581 17.599 5.78051 16.0757 4.25727C14.5525 2.73403 12.4872 1.87727 10.333 1.875ZM10.333 16.875C8.97326 16.875 7.64405 16.4718 6.51347 15.7164C5.38288 14.9609 4.50169 13.8872 3.98134 12.6309C3.46099 11.3747 3.32484 9.99237 3.59011 8.65875C3.85539 7.32513 4.51017 6.10013 5.47165 5.13864C6.43314 4.17715 7.65815 3.52237 8.99177 3.2571C10.3254 2.99183 11.7077 3.12798 12.964 3.64833C14.2202 4.16868 15.2939 5.04987 16.0494 6.18045C16.8048 7.31104 17.208 8.64025 17.208 10C17.2059 11.8227 16.481 13.5702 15.1921 14.8591C13.9032 16.1479 12.1557 16.8729 10.333 16.875ZM14.083 10C14.083 10.1658 14.0172 10.3247 13.9 10.4419C13.7827 10.5592 13.6238 10.625 13.458 10.625H10.958V13.125C10.958 13.2908 10.8922 13.4497 10.775 13.5669C10.6577 13.6842 10.4988 13.75 10.333 13.75C10.1673 13.75 10.0083 13.6842 9.89107 13.5669C9.77386 13.4497 9.70801 13.2908 9.70801 13.125V10.625H7.20801C7.04225 10.625 6.88328 10.5592 6.76607 10.4419C6.64886 10.3247 6.58301 10.1658 6.58301 10C6.58301 9.83424 6.64886 9.67527 6.76607 9.55806C6.88328 9.44085 7.04225 9.375 7.20801 9.375H9.70801V6.875C9.70801 6.70924 9.77386 6.55027 9.89107 6.43306C10.0083 6.31585 10.1673 6.25 10.333 6.25C10.4988 6.25 10.6577 6.31585 10.775 6.43306C10.8922 6.55027 10.958 6.70924 10.958 6.875V9.375H13.458C13.6238 9.375 13.7827 9.44085 13.9 9.55806C14.0172 9.67527 14.083 9.83424 14.083 10Z" fill="white" />
                                        </svg>
                                    }
                                    size="sm"
                                    sx={{
                                        backgroundColor: PRIMARY.P_BLue
                                    }}
                                    onClick={onAddClickHandler}
                                >
                                    Add
                                </Button>
                            </div>
                        </div>
                    </div>
                    <Button

                        sx={{
                            marginTop: "24px",
                            width: "236px",
                            ":disabled": {
                                backgroundColor: PRIMARY.P_Blue,
                                color: BLACK.B_10,
                            }
                        }}
                        endDecorator={<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M17.3172 10.4425L11.6922 16.0675C11.5749 16.1848 11.4159 16.2507 11.25 16.2507C11.0841 16.2507 10.9251 16.1848 10.8078 16.0675C10.6905 15.9503 10.6247 15.7912 10.6247 15.6253C10.6247 15.4595 10.6905 15.3004 10.8078 15.1832L15.3664 10.6253H3.125C2.95924 10.6253 2.80027 10.5595 2.68306 10.4423C2.56585 10.3251 2.5 10.1661 2.5 10.0003C2.5 9.83459 2.56585 9.67562 2.68306 9.55841C2.80027 9.4412 2.95924 9.37535 3.125 9.37535H15.3664L10.8078 4.81753C10.6905 4.70026 10.6247 4.5412 10.6247 4.37535C10.6247 4.2095 10.6905 4.05044 10.8078 3.93316C10.9251 3.81588 11.0841 3.75 11.25 3.75C11.4159 3.75 11.5749 3.81588 11.6922 3.93316L17.3172 9.55816C17.3753 9.61621 17.4214 9.68514 17.4529 9.76101C17.4843 9.83688 17.5005 9.91821 17.5005 10.0003C17.5005 10.0825 17.4843 10.1638 17.4529 10.2397C17.4214 10.3156 17.3753 10.3845 17.3172 10.4425Z" fill="#1C1C1C" fill-opacity="0.1" />
                        </svg>
                        }
                        onClick={onInsertClickHandler}
                        disabled={selectedSubCategory && selectedBrandPlatform && formArray.length > 0 ? false : true}
                    >Insert</Button>
                </div>
                {/* Right Container */}
                <div className="w-full pl-6" >

                    {/* 
                     <div

                        className="ag-theme-quartz h-full" // applying the grid theme
                        style={{ backgroundColor: BLACK.B_5 }} // the grid will fill the size of the parent container
                    >
                        <AgGridReact
                            rowData={rowData}
                            columnDefs={colDefs}
                            rowHeight={120}
                            // getRowHeight={getRowHeight}
                            className="ag-grid-table"
                            getRowId={getRowId}
                        />
                    </div>
                    */}
                    <div className="flex flex-col h-full mt-2.5">
                        <div style={{ height: 32, fontSize: 14, fontWeight: 400, color: BLACK.B_40 }} className="flex flex-row items-center w-full border-b" >
                            <div className="w-1/5">Product Code</div>
                            <div className="w-1/5" >SKU ID</div>
                            <div className="w-1/5">Sub Category</div>
                            <div className="w-1/5">Platform</div>
                            <div className="w-1/5" >Action</div>
                        </div>
                        <div style={{ height: "calc(100vh - 440px)", overflowY: "scroll" }} className="mt-4">
                            {
                                rowData?.map(el => {
                                    return (
                                        <div key={el.id} style={{ fontSize: 14, fontWeight: 400 }} className="flex flex-row justify-start w-full my-1" >
                                            <div className="w-1/5 pt-2 pb-2" >
                                                <Tooltip key={el?.id} arrow title={el?.brand_product_code_message} color="danger" placement="top" variant={"outlined"}>
                                                    <div className="flex items-center justify-center m-1 max-w-fit px-2 py-1 cursor-pointer" style={{ fontSize: 14, fontWeight: 400, backgroundColor: el.brand_product_code_status === "error" ? STATUS.S_Red : BLACK.B_10, color: el.brand_product_code_status === "error" ? BLACK.B_100 : BLACK.B_40, height: 28, borderRadius: 8 }} >
                                                        {el.brand_product_code}
                                                    </div>
                                                </Tooltip>
                                            </div>
                                            <div className="flex items-center w-1/5 pt-2 pb-2">
                                                {el.brand_product_sku_id}
                                            </div>
                                            <div className="w-1/5 pt-2 pb-2">
                                                <Tooltip key={el?.id} arrow title={el?.brand_sub_category_message} color="danger" placement="top" variant={"outlined"}>
                                                    <div className="flex items-center justify-center m-1 max-w-fit px-2 py-1 cursor-pointer" style={{ fontSize: 14, fontWeight: 400, backgroundColor: el.brand_sub_category_status === "error" ? STATUS.S_Red : BLACK.B_10, color: el.brand_sub_category_status === "error" ? BLACK.B_100 : BLACK.B_40, height: 28, borderRadius: 8 }} >
                                                        {el.brand_sub_category}
                                                    </div>
                                                </Tooltip>
                                            </div>
                                            <div className="flex items-center  w-1/5 pt-2 pb-2">
                                                <Tooltip key={el?.id} arrow title={el?.brand_platform_message} color="danger" placement="top" variant={"outlined"}>
                                                    <div className="flex items-center justify-center m-1 max-w-fit px-2 py-1 cursor-pointer" style={{ fontSize: 14, fontWeight: 400, backgroundColor: el.brand_platform_status === "error" ? STATUS.S_Red : BLACK.B_10, color: el.brand_platform_status === "error" ? BLACK.B_100 : BLACK.B_40, height: 28, borderRadius: 8 }} >
                                                        {el.platform}
                                                    </div>
                                                </Tooltip>
                                            </div>
                                            <div className="flex items-center  w-1/5 pt-2 pb-2">
                                                <div onClick={() => onDeleteClickHandler(el?.id)} className="max-w-fit max-h-fit cursor-pointer" >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                        <path d="M20.25 4.5H16.5V3.75C16.5 3.15326 16.2629 2.58097 15.841 2.15901C15.419 1.73705 14.8467 1.5 14.25 1.5H9.75C9.15326 1.5 8.58097 1.73705 8.15901 2.15901C7.73705 2.58097 7.5 3.15326 7.5 3.75V4.5H3.75C3.55109 4.5 3.36032 4.57902 3.21967 4.71967C3.07902 4.86032 3 5.05109 3 5.25C3 5.44891 3.07902 5.63968 3.21967 5.78033C3.36032 5.92098 3.55109 6 3.75 6H4.5V19.5C4.5 19.8978 4.65804 20.2794 4.93934 20.5607C5.22064 20.842 5.60218 21 6 21H18C18.3978 21 18.7794 20.842 19.0607 20.5607C19.342 20.2794 19.5 19.8978 19.5 19.5V6H20.25C20.4489 6 20.6397 5.92098 20.7803 5.78033C20.921 5.63968 21 5.44891 21 5.25C21 5.05109 20.921 4.86032 20.7803 4.71967C20.6397 4.57902 20.4489 4.5 20.25 4.5ZM9 3.75C9 3.55109 9.07902 3.36032 9.21967 3.21967C9.36032 3.07902 9.55109 3 9.75 3H14.25C14.4489 3 14.6397 3.07902 14.7803 3.21967C14.921 3.36032 15 3.55109 15 3.75V4.5H9V3.75ZM18 19.5H6V6H18V19.5ZM10.5 9.75V15.75C10.5 15.9489 10.421 16.1397 10.2803 16.2803C10.1397 16.421 9.94891 16.5 9.75 16.5C9.55109 16.5 9.36032 16.421 9.21967 16.2803C9.07902 16.1397 9 15.9489 9 15.75V9.75C9 9.55109 9.07902 9.36032 9.21967 9.21967C9.36032 9.07902 9.55109 9 9.75 9C9.94891 9 10.1397 9.07902 10.2803 9.21967C10.421 9.36032 10.5 9.55109 10.5 9.75ZM15 9.75V15.75C15 15.9489 14.921 16.1397 14.7803 16.2803C14.6397 16.421 14.4489 16.5 14.25 16.5C14.0511 16.5 13.8603 16.421 13.7197 16.2803C13.579 16.1397 13.5 15.9489 13.5 15.75V9.75C13.5 9.55109 13.579 9.36032 13.7197 9.21967C13.8603 9.07902 14.0511 9 14.25 9C14.4489 9 14.6397 9.07902 14.7803 9.21967C14.921 9.36032 15 9.55109 15 9.75Z" fill="#D72C0D" />
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>

            <Button
                loading={loadingSave}
                sx={{
                    margin: "24px 0px",
                    width: "236px",
                    ":disabled": {
                        backgroundColor: PRIMARY.P_Blue,
                        color: BLACK.B_10,
                    }
                }}
                className="self-end"
                endDecorator={<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M17.3172 10.4425L11.6922 16.0675C11.5749 16.1848 11.4159 16.2507 11.25 16.2507C11.0841 16.2507 10.9251 16.1848 10.8078 16.0675C10.6905 15.9503 10.6247 15.7912 10.6247 15.6253C10.6247 15.4595 10.6905 15.3004 10.8078 15.1832L15.3664 10.6253H3.125C2.95924 10.6253 2.80027 10.5595 2.68306 10.4423C2.56585 10.3251 2.5 10.1661 2.5 10.0003C2.5 9.83459 2.56585 9.67562 2.68306 9.55841C2.80027 9.4412 2.95924 9.37535 3.125 9.37535H15.3664L10.8078 4.81753C10.6905 4.70026 10.6247 4.5412 10.6247 4.37535C10.6247 4.2095 10.6905 4.05044 10.8078 3.93316C10.9251 3.81588 11.0841 3.75 11.25 3.75C11.4159 3.75 11.5749 3.81588 11.6922 3.93316L17.3172 9.55816C17.3753 9.61621 17.4214 9.68514 17.4529 9.76101C17.4843 9.83688 17.5005 9.91821 17.5005 10.0003C17.5005 10.0825 17.4843 10.1638 17.4529 10.2397C17.4214 10.3156 17.3753 10.3845 17.3172 10.4425Z" fill="#1C1C1C" fill-opacity="0.1" />
                </svg>
                }
                disabled={rowData.length > 0 ? false : true}
                onClick={onSaveClickHandler}
            > Save & Continue</Button>

        </div >
    )
}




export default Product;